import { Offcanvas } from 'bootstrap';

const modalList = [];
const modal = document.querySelectorAll('.offcanvas-gallery .offcanvas');


for (var i = 0; i < modal.length; i++) {
    modalList.push(modal[i].getAttribute('id'));
}


modal.forEach((element) => {
    const prevprev = element.querySelector('.modal-prevprev');
    const prev = element.querySelector('.modal-prev');
    const next = element.querySelector('.modal-next');
    const nextnext = element.querySelector('.modal-nextnext');

    var index = modalList.indexOf(element.getAttribute('id'));

    if (index == 0) {
        prevprev.disabled = false;
        prev.disabled = true;
    } else if (index == modalList.length - 1) {
        next.disabled = true;
        nextnext.disabled = false;
    }

    prevprev.addEventListener('click', function (event) {
        Offcanvas.getInstance(element).hide(); // hide current
        new Offcanvas(document.getElementById(modalList[modalList.length - 1])).toggle(); // show prevprev
    })

    prev.addEventListener('click', function (event) {
        Offcanvas.getInstance(element).hide(); // hide current
        new Offcanvas(document.getElementById(modalList[index - 1])).toggle(); // show prev
    })

    next.addEventListener('click', function (event) {
        Offcanvas.getInstance(element).hide(); // hide current
        new Offcanvas(document.getElementById(modalList[index + 1])).toggle(); // show next
    })

    nextnext.addEventListener('click', function (event) {
        Offcanvas.getInstance(element).hide(); // hide current
        new Offcanvas(document.getElementById(modalList[0])).toggle(); // show next
    })
});
